import React, { useState, useEffect } from "react";
import { Button, Card, Form } from "antd";
import HeaderComponent from "components/card/HeaderComponent";
import HeaderModal from "components/modal/HeaderModal";
import { Send, CircleCheck, Gift } from "lucide-react";
import { USABLE_ICONS } from "variables/constants";
import {
  getRewardList,
} from "../../../../../redux/reward/rewardState";
import {
  doEmployeeRewardCreate,
  doEmployeeRewardReset,
} from "../../../../../redux/employeereward/employeeRewardState";
import { connect } from "react-redux";
import AwardeeSelector from "./AwardeeSelector";

const RewardCategoryCard = ({
  recordList,
  pagination,
  nominationSuccess,
  getList,
  doCreate,
  doReset,
}) => {

  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCategory(null);
    form.resetFields();
  };

  useEffect(() => {
    getList({ paginate: pagination?.per_page || 10 });
  }, [getList, pagination?.per_page]);

  useEffect(() => {
    if (nominationSuccess && isModalOpen) {
      closeModal();
      doReset();
    }
  }, [nominationSuccess, isModalOpen, doReset]);

  const handleSubmit = (values) => {
    doCreate(values);
  };

  return (
    <HeaderComponent
      title="Reward Categories"
      titleClass="text-[16px] font-medium"
      description="Select a reward category to nominate a team member"
      descriptionClass="text-sm"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {recordList?.map((category) => (
          <Card
            key={category.rwd_id}
            onClick={() => {
              setSelectedCategory(category);
              setIsModalOpen(true);

              form.resetFields();
              form.setFieldsValue({
                erw_reward_id: category.rwd_id,
              });
            }}
            className={`card-theme ${category.rwd_color_class?.toLowerCase()} rounded-xl cursor-pointer hover:shadow-lg transition-all`}
          >

            <div className="space-y-4">
              <div className="flex flex-col items-start gap-3">
                <div className="flex items-start justify-between w-full">
                  <div className="icon-style p-3 text-white">
                    {category.rwd_icon &&
                      USABLE_ICONS[category.rwd_icon] &&
                      React.createElement(
                        USABLE_ICONS[category.rwd_icon],
                        { className: "h-6 w-6" }
                      )}
                  </div>
                <div>
                  <span className="border status-color font-medium rounded-xl px-1 py-0.5 text-xs">{category.rwd_points} credits</span>
                </div>
                </div>


                <h4 className="card-text text-base">
                  {category.rwd_title}
                </h4>

                <p className="text-[13px] text-muted-foreground">
                  {category.rwd_description}
                </p>
              </div>

              <button
                className="h-8 rounded-2xl w-full icon-style !bg-gradient-to-r text-white inline-flex items-center justify-center font-semibold gap-3"
                onClick={() => {
                  setSelectedCategory(category);
                  setIsModalOpen(true);

                  form.resetFields();
                  form.setFieldsValue({
                    erw_reward_id: category.rwd_id,
                    erw_points_awarded: category.rwd_points,
                  });
                  form.setFieldsValue({
});
                }}
              >
                <Send className="h-4 w-4" /> Award Credits
              </button>
            </div>
          </Card>
        ))}
      </div>

      {isModalOpen && selectedCategory && (
        <HeaderModal
          open={isModalOpen}
          onClose={closeModal}
          title={`Nominate for ${selectedCategory.rwd_title}`}
          titleClass="text-lg font-semibold pt-1 pb-4 flex"
          labelIcon={
            <div className={`card-theme ${selectedCategory.rwd_color_class?.toLowerCase()} invisible`}>
              <div className="icon-style p-2 text-white visible">
                {selectedCategory.rwd_icon &&
                  USABLE_ICONS[selectedCategory.rwd_icon] &&
                  React.createElement(USABLE_ICONS[selectedCategory.rwd_icon], {
                    className: "h-5 w-5"
                  })}
              </div>
            </div>
          }
          description={selectedCategory.rwd_description}
          descriptionClass="text-sm text-gray-700"
          bgcolor={selectedCategory.rwd_color_class?.toLowerCase() || "white"}
          cardBorder={`border-${selectedCategory.rwd_color_class?.toLowerCase() || "gray-200"}`}
          width={500}
          footer={
            <div className="p-4 flex justify-end gap-2">
              <Button
                className="inline-flex items-center justify-center gap-2 rounded-xl text-sm text-gray-800 h-9 px-4"
                onClick={closeModal}
              >
                Cancel
              </Button>

              <div className={`card-theme ${selectedCategory.rwd_color_class?.toLowerCase()} invisible`}>
                <Button
                  icon={<Gift size={16} />}
                  className="!bg-gradient-to-r icon-style inline-flex items-center justify-center visible text-white p-4 h-9 font-medium"
                  loading={submitting}
                  onClick={() => form.submit()}
                >
                  Award Credits
                </Button>
              </div>
            </div>
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
          >
            <Form.Item name="erw_reward_id" hidden>
              <input type="hidden" />
            </Form.Item>

            <AwardeeSelector
              points={selectedCategory.rwd_points} 
              category={selectedCategory.rwd_color_class}
            />
          </Form>
        </HeaderModal>
      )}
    </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.reward.rewardList?.items,
  pagination: state.reward.rewardList?.pagination,
  nominationSuccess: state.employeeReward.employeeRewardDetails?.success,
  loading: state.employeeReward.employeeRewardDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  getList: (params) => dispatch(getRewardList(params)),
  doCreate: (data) => dispatch(doEmployeeRewardCreate(data)),
  doReset: () => dispatch(doEmployeeRewardReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RewardCategoryCard);